import { render, staticRenderFns } from "./SectionSplitter.vue?vue&type=template&id=98d068a6"
import script from "./SectionSplitter.vue?vue&type=script&lang=ts"
export * from "./SectionSplitter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d068a6')) {
      api.createRecord('98d068a6', component.options)
    } else {
      api.reload('98d068a6', component.options)
    }
    module.hot.accept("./SectionSplitter.vue?vue&type=template&id=98d068a6", function () {
      api.rerender('98d068a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/SectionSplitter.vue"
export default component.exports